import { ECallbackPopupActionTypes } from '../../actions/callbackPopup';
import { TReduxActions } from '../../types/redux';
import { ICallbackPopupState } from '../../types/callback';

const INITIAL_STATE: ICallbackPopupState = {
  isOpen: false,
  opener: null,
};

export function callbackPopupReducer(
  state: ICallbackPopupState = INITIAL_STATE,
  action: TReduxActions,
): ICallbackPopupState {
  switch (action.type) {
    case ECallbackPopupActionTypes.OpenPopup:
      return {
        ...state,
        isOpen: true,
        opener: action.payload,
      };

    case ECallbackPopupActionTypes.ClosePopup:
      return {
        ...state,
        isOpen: false,
        opener: null,
      };

    default:
      return state;
  }
}
